module.exports = __webpack_public_path__ + "media/icons/square261-95ba9116.png";